import { useEffect } from 'react';

// DAT (self-hosted Umami) analytics tracker — LB FEAT (dat-umami-tracker).
//
// Runtime hostname gate: injects the Umami script ONLY on legacybridge.com.
// Staging (lb.truut.com) and localhost emit nothing — no build-time env var needed
// since both staging and prod share the same CRA build artifact.
//
// Obfuscated collection surface: /p.js + dat.psychogra.ph keeps the tag from
// reading as a recognizable analytics script. Cookieless, no PII, no consent banner.
//
// Idempotent: safe to render multiple times — injects at most one script tag.
// Umami auto-tracks SPA route changes via its history API hook; no per-route wiring.

const WEBSITE_ID = 'a08d96bb-b22d-4183-8830-001020339b68';
const SCRIPT_SRC = 'https://dat.psychogra.ph/p.js';

export default function Analytics() {
    useEffect(() => {
        // Prod-only gate — emit nothing on staging or local
        if (window.location.hostname !== 'legacybridge.com') return;

        // Idempotent — bail out if script already injected
        if (document.querySelector(`script[data-website-id="${WEBSITE_ID}"]`)) return;

        const script = document.createElement('script');
        script.defer = true;
        script.src = SCRIPT_SRC;
        script.setAttribute('data-website-id', WEBSITE_ID);
        document.head.appendChild(script);
    }, []);

    return null;
}
